function formatCurrency(value, useMoneySign = true, useDecimal = false) {
  let valueInt = Number(value);
  if (Number.isNaN(valueInt)) {
    valueInt = 0;
  }

  let formattedValue = valueInt.toLocaleString('pt-BR', {
    style: useDecimal ? 'decimal' : 'currency',
    currency: 'BRL'
  });

  if (!useMoneySign) {
    formattedValue = formattedValue.replace('R$', '');
  }

  formattedValue = formattedValue.trim();

  return formattedValue;
}

export default formatCurrency;
